import { Phone, Mail, MapPin, Facebook, Instagram, Youtube } from "lucide-react";
import { SITE, NAV } from "../../lib/content";
import { scrollTo } from "./Navbar";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-ink text-white noise overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="grid place-items-center h-10 w-10 bg-flame text-white font-heading font-extrabold rounded-md">NK</span>
              <span className="font-heading font-extrabold text-lg tracking-tight">{SITE.name}</span>
            </div>
            <p className="mt-4 font-heading text-2xl font-bold tracking-tight text-white/90">{SITE.tagline}</p>
            <p className="mt-3 text-white/50 max-w-sm text-sm">
              Best tuition centre in Hajo for Class 9 &amp; 10 Maths, Science coaching in Kamrup, and
              Class 11 &amp; 12 Physics coaching (CBSE &amp; AHSEC).
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Explore</div>
            <ul className="space-y-2">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => scrollTo(n.id)}
                    data-testid={`footer-nav-${n.id}`}
                    className="text-white/70 hover:text-flame transition-colors text-sm"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Get in touch</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-flame" /><a href={`tel:${SITE.phoneIntl}`} className="hover:text-flame">{SITE.phone}</a></li>
              <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-flame" /><a href={`mailto:${SITE.email}`} className="hover:text-flame break-all">{SITE.email}</a></li>
              <li className="flex items-start gap-3"><MapPin className="h-4 w-4 text-flame mt-0.5" /><span className="text-white/70">{SITE.address}</span></li>
            </ul>
            <div className="mt-5 flex gap-3">
              {[Facebook, Instagram, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-${i}`}
                  className="grid place-items-center h-10 w-10 rounded-full border border-white/15 hover:bg-flame hover:border-flame transition-colors"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/40 text-xs">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <p>Learn. Understand. Excel.</p>
        </div>
      </div>
    </footer>
  );
}
